
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./reactjs-popup.cjs.production.min.js')
} else {
  module.exports = require('./reactjs-popup.cjs.development.js')
}



//////////////////
// WEBPACK FOOTER
// ./~/reactjs-popup/dist/index.js
// module id = 54
// module chunks = 0